import GameService from '@base/features/game/model/gameService';
// import LobbyService from '@base/features/lobby/model/lobbyService';
import { IMessage } from '@base/features/message/message';
import BuyTicketsModal from '@base/features/tickets/components/buyTicketsModal';
import { ITicketService } from '@base/features/tickets/model/interfaces';
import { useBehaviorSubject, useSubject } from '@base/utils/helpers';
import Fireworks from '@ui-kit/components/confetti';
import Message from '@ui-kit/components/message';
import React from 'react';
import { container } from 'tsyringe';
import { IModalProvider } from '../model/interfaces';
import ModalTermsAndConditions from './modalTermsAndConditions';
import ModalWarning from './ModalWarning';

export default function Modals() {
  const messageProvider: IMessage = container.resolve('message');
  const gameService: GameService = container.resolve('gameService');
  const message = useBehaviorSubject(messageProvider.onMessage);
  const modalProvider: IModalProvider = container.resolve('modalProvider');
  const ticketsService: ITicketService = container.resolve('ticketsService');

  const modal = useBehaviorSubject(modalProvider.onModal);
  const tableId = useSubject(modalProvider.onTermsAndConditions);
  const purchaseMethods = useSubject(ticketsService.onTicketsModal);
  const isConfetti = useBehaviorSubject(gameService.isTournamentWinnerAnimation);

  return (
    <>
      {modal && <ModalWarning modal={modal} />}
      {message && <Message message={message} />}
      {isConfetti && (
        <Fireworks
          isFire={isConfetti}
          stopAnimation={() => gameService.isTournamentWinnerAnimation.next(false)}
        />
      )}
      {tableId && <ModalTermsAndConditions tableId={tableId} />}
      {purchaseMethods && (
        <BuyTicketsModal close={() => ticketsService.closePaymentModal()} methods={purchaseMethods} />
      )}
    </>
  );
}
